import { useEffect, useRef } from "react";



export function About() {
    const focusRef = useRef(null);

    useEffect(() => {
        focusRef.current?.focus();
    }, []);


    return (
        <div className="bg-gray-100 text-gray-900 min-h-screen">
            <div ref={focusRef} tabIndex={0} className="sr-only">Start of [Page Name] Page</div>
            {/* Header Section */}
            <header className="bg-indigo-800 py-6 rounded">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl font-bold text-white">About SendFalcon</h1>
                    <p className="mt-2 text-lg text-indigo-50">Secure, Self-Hosted Email for Your Business</p>
                </div>
            </header>

            {/* Main Content */}
            <main className="container mx-auto px-4 py-12">
                {/* Introduction Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Our Mission</h2>
                    <p className="text-gray-700 leading-relaxed">
                        SendFalcon empowers businesses to take control of their email communications with a secure, self-hosted email service. Designed to be installed on your own infrastructure, SendFalcon ensures privacy and flexibility, allowing seamless communication within your organization and with external recipients.
                    </p>
                </section>

                {/* Features Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Why SendFalcon?</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Self-Hosted Control</h3>
                            <p className="text-indigo-100">Install SendFalcon on your own servers to maintain full control over your email data and infrastructure.</p>
                        </div>
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Secure Communication</h3>
                            <p className="text-indigo-100">End-to-end encryption protects your emails, ensuring secure communication within and outside your organization.</p>
                        </div>
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Flexible Connectivity</h3>
                            <p className="text-indigo-100">Communicate effortlessly with internal teams or external partners while maintaining security and reliability.</p>
                        </div>
                    </div>
                </section>

                {/* Vision Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Our Vision</h2>
                    <p className="text-gray-700 leading-relaxed">
                        SendFalcon is committed to redefining business email by offering a self-hosted solution that prioritizes privacy, security, and control. We envision a future where organizations can communicate confidently, free from reliance on third-party email providers, with a system tailored to their unique infrastructure.
                    </p>
                </section>
            </main>
        </div>
    );
};

